export default __webpack_public_path__ + "static/media/midroll-example.299638ce.png";